import { createContext, useContext, useEffect, useState, type PropsWithChildren } from 'react';
import { getContent, pageIds, setContent, type PageId } from './store';
const ContentVersion = createContext(0);
export function ContentProvider({children}: PropsWithChildren) {
  const [version, setVersion] = useState(0);
  useEffect(() => {
    let active = true;
    async function refresh() {
      await Promise.all(pageIds.map(async page => {
        try {
          const response = await fetch(`/api/cms/pages/${page}/published`, {cache: 'no-store'});
          if (response.ok) { const data = await response.json(); if (active && data.ok) setContent(page, data.value.content); }
        } catch { /* Keep the shipped content available when CMS is offline. */ }
      }));
      if (active) setVersion(value => value + 1);
    }
    void refresh();
    window.addEventListener('focus', refresh);
    return () => { active = false; window.removeEventListener('focus', refresh); };
  }, []);
  return <ContentVersion.Provider value={version}>{children}</ContentVersion.Provider>;
}
export function useContent<K extends PageId>(page: K) { useContext(ContentVersion); return getContent(page); }
